import { http } from '../api/http';
import type { KycDocStatus, KycDocType, KycCaseStatus } from './profile.service';

export interface AdminKycDocumentStatus {
  id: string;
  docType: KycDocType;
  status: KycDocStatus;
  uploadedAt?: string;
  notes?: string;
  mimeType?: string;
  originalName?: string;
  fileSize?: number;
  fileUrl?: string;
}

export interface AdminKycCaseItem {
  userId: number;
  name: string;
  email: string;
  status: KycCaseStatus;
  updatedAt?: string;
  documents?: AdminKycDocumentStatus[];
}

export interface AdminKycCaseListResponse {
  items: AdminKycCaseItem[];
  total?: number;
}

export interface AdminKycCaseDetailResponse {
  case: AdminKycCaseItem | null;
}

export const AdminKycService = {
  listCases(params?: { status?: string; q?: string; page?: number; pageSize?: number }) {
    const qs = new URLSearchParams();
    if (params?.status) qs.set('status', params.status);
    if (params?.q) qs.set('q', params.q);
    if (params?.page) qs.set('page', String(params.page));
    if (params?.pageSize) qs.set('pageSize', String(params.pageSize));
    const suffix = qs.toString();
    return http<AdminKycCaseListResponse>(`/v1/admin/kyc/cases${suffix ? `?${suffix}` : ''}`);
  },

  getCase(userId: number) {
    return http<AdminKycCaseDetailResponse>(`/v1/admin/kyc/cases/${userId}`);
  },

  reviewDocument(docId: string, payload: { status: 'APPROVED' | 'REJECTED'; notes?: string }) {
    return http<{ ok: true }>(`/v1/admin/kyc/documents/${docId}/review`, { method: 'POST', body: payload });
  },

  runWorkflow(userId: number) {
    return http<{ ok: true }>(`/v1/admin/kyc/${userId}/run`, { method: 'POST' });
  }
};
